module.exports = __webpack_public_path__ + "img/u121.0b7eee93.png";